export enum PortalType {
  Admin = 1,
  Client = 2,
}
